import React from 'react';

const ZCnetLogo = ({ size = 'default', className = '' }) => {
  // Tamanhos predefinidos
  const sizes = {
    small: { width: 130, height: 45, fontSize: 18, dotSize: 6, dotSpacing: 3 },
    default: { width: 200, height: 70, fontSize: 32, dotSize: 10, dotSpacing: 6 },
    large: { width: 280, height: 100, fontSize: 48, dotSize: 14, dotSpacing: 8 }
  };

  const config = sizes[size] || sizes.default;
  const padding = 12;
  const dotsStartX = padding + 4;
  const dotsStartY = config.height / 2;
  const textStartX = dotsStartX + config.dotSize * 2 + config.dotSpacing * 2 + 12;
  const eX = textStartX + config.fontSize * 1.1;
  const eY = config.height / 2;

  return (
    <div 
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: config.width, height: config.height }}
    >
      <svg
        width={config.width}
        height={config.height}
        viewBox={`0 0 ${config.width} ${config.height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Fundo com borda arredondada - azul escuro */}
        <rect
          x="2"
          y="2"
          width={config.width - 4}
          height={config.height - 4}
          rx="14"
          fill="#1e3a8a"
          stroke="#2563eb"
          strokeWidth="2"
        />
        
        {/* Quatro pontos em grade 2x2 */}
        <g>
          {/* Ponto superior esquerdo - azul escuro */}
          <circle
            cx={dotsStartX}
            cy={dotsStartY - config.dotSpacing - config.dotSize / 2}
            r={config.dotSize / 2}
            fill="#1e40af"
          />
          {/* Ponto superior direito - azul médio */}
          <circle
            cx={dotsStartX + config.dotSize + config.dotSpacing}
            cy={dotsStartY - config.dotSpacing - config.dotSize / 2}
            r={config.dotSize / 2}
            fill="#3b82f6"
          />
          {/* Ponto inferior esquerdo - azul escuro médio */}
          <circle
            cx={dotsStartX}
            cy={dotsStartY + config.dotSpacing + config.dotSize / 2}
            r={config.dotSize / 2}
            fill="#2563eb"
          />
          {/* Ponto inferior direito - azul claro */}
          <circle
            cx={dotsStartX + config.dotSize + config.dotSpacing}
            cy={dotsStartY + config.dotSpacing + config.dotSize / 2}
            r={config.dotSize / 2}
            fill="#60a5fa"
          />
        </g>

        {/* Texto ZCnet */}
        <text
          x={textStartX}
          y={config.height / 2 + config.fontSize / 3}
          fontSize={config.fontSize}
          fontFamily="Roboto, sans-serif"
          fontWeight="700"
          fill="white"
        >
          <tspan fontWeight="700" fontSize={config.fontSize}>ZC</tspan>
          <tspan fontWeight="500" fontSize={config.fontSize * 0.75}>net</tspan>
        </text>

        {/* Três linhas curvas acima do "e" (ícone Wi-Fi) */}
        <g>
          {/* Linha superior (mais longa) */}
          <path
            d={`M ${eX - 6} ${eY - config.fontSize / 2 - 2} 
                Q ${eX} ${eY - config.fontSize / 2 - 6}
                  ${eX + 6} ${eY - config.fontSize / 2 - 2}`}
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
          />
          {/* Linha do meio */}
          <path
            d={`M ${eX - 4} ${eY - config.fontSize / 2 + 1} 
                Q ${eX} ${eY - config.fontSize / 2 - 2}
                  ${eX + 4} ${eY - config.fontSize / 2 + 1}`}
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
          />
          {/* Linha inferior (mais curta) */}
          <path
            d={`M ${eX - 2} ${eY - config.fontSize / 2 + 4} 
                Q ${eX} ${eY - config.fontSize / 2 + 2}
                  ${eX + 2} ${eY - config.fontSize / 2 + 4}`}
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            fill="none"
          />
        </g>
      </svg>
    </div>
  );
};

export default ZCnetLogo;
